import React from "react";
import { 
    Level, LevelItem, Grid, GridItem, ClipboardCopy, Divider, Content
} from '@patternfly/react-core';
import { CONFIG } from '../../../../../config/config'

const StorageInfo = ({
  userProfile,
  poolName,
  iscsi_target,
  loading
}) => {
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL
  const unc_path = `\\\\${CONFIG.SMB_IP}\\${userProfile?.username}`
  const winsfp = <Content component="a" target="_blank" href="https://github.com/winfsp/winfsp/releases/download/v2.1/winfsp-2.1.25156.msi"><small>WinFSP</small></Content>
  const sshfs = <Content component="a" target="_blank" href="https://github.com/winfsp/sshfs-win/releases/download/v3.5.20357/sshfs-win-3.5.20357-x64.msi"><small>SSHFS-Win</small></Content>
  const instrukcja = <Content component="a" target="_blank" href={`${frontendUrl}/ti/files/inf.03/sftp-smb-connection-help.pdf`}><small>Zobacz</small></Content>
  return (
    <>
    <br />
    <Grid
      hasGutter
      span={12}
      style={{
          fontSize: "13px",
          lineHeight: "1.6"
      }}
    >
      <>
      <GridItem span={6}>
        {userProfile.is_superuser && (
          <>
          {/* Target IQN */}
          <Level>
              <LevelItem><small><b>ISCSI target:</b></small></LevelItem>
              <LevelItem>
                <ClipboardCopy 
                  copyAriaLabel="Copy inline compact example"
                  hoverTip="Kopiuj"
                  clickTip="Skopiowano"
                  variant="inline-compact"
                  style={{marginRight: "0px", paddingRight: "0px"}}
                >
                  {iscsi_target.target_iqn}
                </ClipboardCopy>
              </LevelItem>
          </Level>
          {/* Pool */}
          <Level>
              <LevelItem><small><b>Pool:</b></small></LevelItem>
              <LevelItem>
                  {loading ? "" : poolName}
              </LevelItem>
          </Level>
          </>
        )}
        {/* Aplikacje */}
        <Level>
          <LevelItem><small><b>Wmagane aplikacje:</b></small></LevelItem>
          <LevelItem>
              {sshfs}, {winsfp}
          </LevelItem>
        </Level>
      </GridItem>
      <GridItem span={6}>
        {/* Sessions */}
        {/* <Level>
            <LevelItem><small><b>Sessions:</b></small></LevelItem>
            <LevelItem>
                {loading ? "" : iscsi_target.info.num_sessions}
            </LevelItem>
        </Level> */}
        {userProfile.is_superuser && (
          <>
          {/* Portals */}
          <Level>
              <LevelItem><small><b>Portals:</b></small></LevelItem>
              <LevelItem>
                  {!loading && iscsi_target?.portals?.length > 0 && (
                    iscsi_target.portals.map((p, idx) => (
                      <span key={idx}>
                        {p.host}, {p.ip}
                      </span>
                    ))
                  )}
              </LevelItem>
          </Level>
          {/* Acl */}
          <Level>
              <LevelItem><small><b>Acl:</b></small></LevelItem>
              <LevelItem>
                  {loading ? "" : `${iscsi_target.acl_enabled}`}
              </LevelItem>
          </Level>
        </>
        )}
          {/* Instrukcja */}
          <Level>
              <LevelItem><small><b>Instrukcja:</b></small></LevelItem>
              <LevelItem>
                  {instrukcja}
              </LevelItem>
          </Level>
      </GridItem>
      </>
    </Grid>
    <Divider />
    </>
  );
};

export default StorageInfo;